import { render, staticRenderFns } from "./addCommunity.vue?vue&type=template&id=f4185442&scoped=true"
import script from "./addCommunity.vue?vue&type=script&lang=js"
export * from "./addCommunity.vue?vue&type=script&lang=js"
import style0 from "./addCommunity.vue?vue&type=style&index=0&id=f4185442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4185442",
  null
  
)

export default component.exports